var React = require('react');

function Ionic (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#4e8ef7;}")),React.createElement("title",{"key":1},"Artboard 5"),React.createElement("g",{"id":"original","key":2},[React.createElement("circle",{"className":"cls-1","cx":"64","cy":"64","r":"24.08","key":0}),React.createElement("path",{"className":"cls-1","d":"M113.14,23.14a8.27,8.27,0,0,0-13.7-6.25,59,59,0,1,0,11.67,11.67A8.24,8.24,0,0,0,113.14,23.14ZM64,121A57,57,0,1,1,98.1,18.36a8.27,8.27,0,0,0,11.53,11.53A57,57,0,0,1,64,121Z","key":1})])]);
}

Ionic.displayName = "Ionic";

Ionic.defaultProps = {"id":"Ionic","viewBox":"0 0 128 128"};

module.exports = Ionic;

Ionic.default = Ionic;



//////////////////
// WEBPACK FOOTER
// ./src/images/inline-svg/ionic.svg
// module id = 880
// module chunks = 35783957827783